// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingPage_wrapper__36A16","loader":"LoadingPage_loader__3n3Wv","spin":"LoadingPage_spin__ifkpO"};